import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface LinkProps {
    addLink: any;
    editLink: any;
    setModalVisible: any;
    link: any;
}

const MAX_DESCRIPTION_LENGTH = 50;

export default function CreateLink({ addLink, editLink, setModalVisible, link }: LinkProps) {
    const [linkName, setLinkName] = useState(link ? link.name : '');
    const [linkUrl, setLinkUrl] = useState(link ? link.url : '');
    const [linkDescription, setLinkDescription] = useState(link ? link.description : '');

    function closeModal() {
        setModalVisible(false);
    }

    function addNewLink() {
        const added = addLink(linkName, linkDescription, linkUrl);
        if (added) {
            closeModal();
        }
    }

    function updateLink() {
        const updated = editLink(link.id, linkName, linkDescription, linkUrl);
        if (updated) {
            closeModal();
        }
    }

    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <Label>Link Text</Label>
                <Input
                    value={linkName}
                    onChange={(e) => setLinkName(e.target.value)}
                    placeholder="e.g. Pricing"
                    autoFocus
                />
            </div>

            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <Label>Description</Label>
                    <span className="text-xs text-muted-foreground">
                        {linkDescription.length}/{MAX_DESCRIPTION_LENGTH}
                    </span>
                </div>
                <Textarea
                    value={linkDescription}
                    onChange={(e) => setLinkDescription(e.target.value)}
                    placeholder="Short description shown with the link"
                    maxLength={MAX_DESCRIPTION_LENGTH}
                    rows={2}
                    className="resize-none"
                />
            </div>

            <div className="space-y-2">
                <Label>URL</Label>
                <Input
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                    placeholder="https://example.com/pricing"
                />
            </div>

            <div className="flex justify-end">
                <Button onClick={link ? updateLink : addNewLink}>
                    {link ? 'Save Link' : 'Create Link'}
                </Button>
            </div>
        </div>
    );
}
